import type { ChangeEvent } from 'react';
import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import SearchInput from '@decisiv/ui-components/lib/components/SearchInput';
import { P } from '@decisiv/ui-components/lib/components/Typography';

/** 220px is the search width the PD-5930 UX review set for every Team page tab. */
export const TOOLBAR_SEARCH_WIDTH = 220;

// When the toolbar runs out of room the label moves above the input instead
// of breaking into one word per line (Figma 686-136155).
const Group = styled(Flex)`
  flex: 0 1 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: ${rem(spacing.base * 0.5)} ${rem(spacing.base)};
  margin-left: auto;
`;

const Label = styled(P)`
  white-space: nowrap;
`;

// SearchInput is fluid (`flex: 1`) and ignores `className`, so the width
// comes from this wrapper.
const InputWrapper = styled(Flex)<{ $width: number }>`
  width: ${({ $width }) => rem($width)};
`;

interface ToolbarSearchProps {
  /** Shown left of the input, ending with a colon, e.g. "Search Depots by Name:". */
  label: string;
  name: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  width?: number;
}

/** The labelled search at the right of a Fleet Management filters toolbar. */
export default function ToolbarSearch({
  label,
  name,
  value,
  onChange,
  disabled,
  width = TOOLBAR_SEARCH_WIDTH,
}: ToolbarSearchProps) {
  return (
    <Group>
      <Label size="small">{label}</Label>
      <InputWrapper $width={width}>
        <SearchInput
          value={value}
          onChange={onChange}
          hideLabel
          aria-label={label}
          name={name}
          size="small"
          disabled={disabled}
        />
      </InputWrapper>
    </Group>
  );
}
